import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withDetailedIcon } from '../DetailedIcon';
var innerSvg = '<path class="DetailedIcon__secondary-color-fill" d="M39.729,23.724H31.281V4.414A2.421,2.421,0,0,0,28.867,2H19.212A2.421,2.421,0,0,0,16.8,4.414v19.31H8.35c-1.327,0-1.671.793-.763,1.761l14.8,15.789a2.24,2.24,0,0,0,3.3,0l14.8-15.789C41.4,24.517,41.057,23.724,39.729,23.724Z"/><path class="DetailedIcon__foreground-color-fill" d="M22.8,4H8.4A2.4,2.4,0,0,0,6,6.4V37.6A2.4,2.4,0,0,0,8.4,40H22.8a2.4,2.4,0,0,0,2.4-2.4V6.4A2.4,2.4,0,0,0,22.8,4Zm-12,2.4A1.2,1.2,0,0,0,12,7.6h7.2a1.2,1.2,0,0,0,1.2-1.2h2.4v24H8.4V6.4ZM8.4,37.6V32.8H22.8v4.8Z"/><circle class="DetailedIcon__accent-color-fill" cx="15.6" cy="35.436" r="1.2"/>';
export var AppDownloadSVG = function AppDownloadSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
AppDownloadSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withDetailedIcon(AppDownloadSVG);